module.exports = __webpack_public_path__ + "img/logo.6d465e0.svg";